import React from 'react';
import ProductImage from './ProductImage';
import ProductInfo from './ProductInfo';
import { Teacher } from './TeacherCard';
import { Product } from 'ai-api/types/purchase';

interface ProductDetailsProps {
    product: Product | null;
    descriptionExpanded: boolean;
    setDescriptionExpanded: (expanded: boolean) => void;
    teacherExpanded: boolean;
    setTeacherExpanded: (expanded: boolean) => void;
    calendarExpanded: boolean;
    setCalendarExpanded: (expanded: boolean) => void;
    teachers: Teacher[];
    selectedTeacher: Teacher | null;
    setSelectedTeacher: (teacher: Teacher) => void;
    selectedDate: Date | null;
    setSelectedDate: (date: Date | null) => void;
    selectedTime: Date | null;
    setSelectedTime: (time: Date) => void;
    disabled?: boolean;
}

const ProductDetails: React.FC<ProductDetailsProps> = ({
    product,
    descriptionExpanded,
    setDescriptionExpanded,
    teacherExpanded,
    setTeacherExpanded,
    calendarExpanded,
    setCalendarExpanded,
    teachers,
    selectedTeacher,
    setSelectedTeacher,
    selectedDate,
    setSelectedDate,
    selectedTime,
    setSelectedTime,
    disabled = false
}) => {
    return (
        <div className={`product-container ${disabled ? 'disabled' : ''}`}>
            <ProductImage image={product?.image} name={product?.name} />
            
            <ProductInfo
                productName={product?.name}
                descriptionExpanded={descriptionExpanded}
                setDescriptionExpanded={setDescriptionExpanded}
                teacherExpanded={teacherExpanded}
                setTeacherExpanded={setTeacherExpanded}
                calendarExpanded={calendarExpanded}
                setCalendarExpanded={setCalendarExpanded}
                teachers={teachers}
                selectedTeacher={selectedTeacher}
                setSelectedTeacher={setSelectedTeacher}
                selectedDate={selectedDate}
                setSelectedDate={setSelectedDate}
                selectedTime={selectedTime}
                setSelectedTime={setSelectedTime}
                disabled={disabled}
            />
        </div>
    );
};

export default ProductDetails;